(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 9502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1503);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6268);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2676);





var PrivacyPolicy = function PrivacyPolicy(props) {
  var storeData = props.storeData,
      themeData = props.themeData;

  var _ref = (storeData === null || storeData === void 0 ? void 0 : storeData.legalInfo) || {},
      _ref$privacy = _ref.privacy,
      privacy = _ref$privacy === void 0 ? "" : _ref$privacy;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("main", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
        className: "sidepage-title",
        children: "Privacy Policy"
      }), (privacy === null || privacy === void 0 ? void 0 : privacy.trim()) != "" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "sidepage-content",
        dangerouslySetInnerHTML: {
          __html: privacy
        }
      }) : null]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      theme: themeData
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PrivacyPolicy);

/***/ }),

/***/ 8989:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return __webpack_require__(9502);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9248,7234,6166,3352,9774,2888,179], function() { return __webpack_exec__(8989); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);